import { Component, OnInit, ViewChild } from "@angular/core";
import { DialogService } from "ng2-bootstrap-modal";
import { ErrorComponent } from "app/popup/error.component";
import { AlertComponent } from "app/popup/alert.component";
import { UtilityServiceService } from "app/services/utility-service.service";
import { PermitTypeService } from "app/services/permit-type.service";
import { ToastrService } from "ngx-toastr";
import { TableModule, Table } from "primeng/table";
import { AutoCompleteModule } from "primeng/autocomplete";
import { FilterService } from "app/shared/filter/filter.service";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PermitTypeFormConfig } from "app/shared/filter/filter.constant";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";

import {
  INT_PERMIT_TYPE_ACTIONS,
  PERMIT_TYPE_ACTIONS,
} from "app/shared/actions/actions.constants";
import { Router } from "@angular/router";

@Component({
  selector: "app-list-permit-type",
  templateUrl: "./list-permit-type.component.html",
  styleUrls: ["./list-permit-type.component.scss"],
})
export class ListPermitTypeComponent implements OnInit {
  pTypes: any = [];
  isRemove = false;
  removeRef: any;
  lblHeading = "";
  loading: boolean = true;
  //filter Items
  keyword: any = {};
  filterStatus: any;
  code: string;
  description: string;
  appFees: string;
  permitFees: string;
  selectedItems: any = [];
  filterConfig = PermitTypeFormConfig;
  @ViewChild("tbpTypes ") table: Table;
  @ViewChild("content") modal: NgbModal;
  selectedPermitData = null;
  placeholder = "Search by Name";
  popoverTitle = "Delete Vehicle Make";
  popoverMessage = "Are you sure you want to delete Permit Type?";
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = "";
  message = "Loading Permit Types...";
  total: number = 0;
  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;
  closeResult: string = "";
  permitTypeActions = INT_PERMIT_TYPE_ACTIONS;

  constructor(
    private permitService: PermitTypeService,
    public utility: UtilityServiceService,
    private router: Router,
    private toastService: ToastNotificationService,
    private toastr: ToastrService,
    private filterCarrier: FilterService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.onChangeHeandig();
    this.reload();
    this.utility.page = 1;
  }

  reload() {
    this.isLoading = true;
    this.permitService.getAll().subscribe(
      (result) => {
        this.pTypes = result;
        this.total = this.pTypes.length;
        this.utility.onSort(1);
        //console.log(this.pTypes);
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.isEmpty = true;
        //console.log(error);
      }
    );
  }

  onDelete(id: any) {
    this.permitService.delete(id).subscribe(
      (result) => {
        // this.dialogService.addDialog(AlertComponent, { title: 'Delete Permit Type', message: `Permit Type ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
        this.toastService.success(
          `Permit Type ${this.removeRef.code} deleted.`,
          "Delete Permit Type"
        );
        if (result != null) {
          this.onNo();
          this.reload();
          this.modalService.dismissAll();
          this.table.reset();
        }
        this.onChangeHeandig();
      },
      (error) => {
        error = error.json();
        // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Permit Type', message: `Permit Type ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
        this.toastService.error(
          `Permit Type ${this.removeRef.code} was not deleted.`,
          "Delete Permit Type"
        );
      }
    );
  }

  onConfirm(doc: any, content) {
    // this.removeRef = doc;
    // this.deleteConfirm = `Are you sure you want to delete Permit Type <strong>${this.removeRef.code}</strong>?`;
    // this.onChangeHeandig(false);
    // this.isRemove = true;

    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Carrier Type <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeandig(false);
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          console.log(result);

          this.closeResult = `Closed with: ${result}`;
          // this.activeModal.close()
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = change ? "Permit Types" : "Delete Permit Type";
  }

  showIndicator = (indicator: number, type = 1) => {
    return type == 1
      ? indicator == 1
        ? "Freight"
        : "Passenger"
      : indicator == 1
      ? "Temporary"
      : "Long-term";
  };

  showPeriod = (obj: any) => {
    let msg = "";
    if (obj.permit_days > 0) {
      msg = `Permit days {${obj.permit_days}}`;
    } else if (obj.permit_months > 0) {
      msg = `Permit months {${obj.permit_months}}`;
    } else if (obj.permit_years > 0) {
      msg = `Permit years {${obj.permit_years}}`;
    }
    return msg;
  };

  onActivityChange(event) {
    const value = event.target.value;
    if (value && value.trim().length) {
      const activity = parseInt(value);

      if (!isNaN(activity)) {
        this.table.filter(activity, "activity", "gte");
      }
    }
  }

  applyFilter(filters) {
    let payload = [];
    if (filters) {
      for (const key in filters) {
        const element = filters[key];
        if (element) {
          let queryParam = `${key}=${element}`;
          payload.push(queryParam);
        }
      }
      let url = `?${payload.join("&")}`;
      console.log(url);
      this.getFilterResponse(url);
    } else {
      this.reload();
    }
  }

  getFilterResponse(params) {
    this.permitService.getAllByFilter(params).subscribe(
      (result) => {
        console.log(result);
        this.pTypes = result;
        this.total = this.pTypes.length;
        this.utility.onSort(1);
        this.isLoading = false;
      },
      (error) => {
        console.log(error);
        this.pTypes = [];
        this.isLoading = false;
        this.isEmpty = true;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  CheckedPermit(event, item) {
    if (event.target.checked) {
      this.selectedPermitData = item;
      console.log(this.selectedPermitData);
    } else {
      this.selectedPermitData = null;
    }
  }

  doPermitAction(event: any) {
    if (event.value == PERMIT_TYPE_ACTIONS.AddPermit) {
      this.router.navigateByUrl("/permit/type/add");
    } else if (event.value == PERMIT_TYPE_ACTIONS.DeletePermit) {
      this.selectedPermitData == null
        ? this.toastr.warning("Please select the permit type first!")
        : this.onConfirm(this.selectedPermitData, this.modal);
    } else if (event.value == PERMIT_TYPE_ACTIONS.EditPermit) {
      this.selectedPermitData == null
        ? this.toastr.warning("Please select the permit type first!")
        : this.router.navigate([
            "/permit/type/edit",
            this.selectedPermitData.id,
          ]);
    }
  }
}
